import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61315b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "achievement-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "achievement-close-wrap" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "achievement-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bi bi-x-lg" })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "achievement-logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/machines/challs.png",
    class: "avatar-img img-fluid floating",
    alt: "challenge achievement"
  })
], -1))
const _hoisted_4 = { class: "achievement-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "bi bi-check-circle-fill text-success fs-2" }, null, -1))
const _hoisted_6 = { class: "achievement-message-primary" }
const _hoisted_7 = { class: "achievement-message-secondary" }
const _hoisted_8 = { class: "achievement-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "achievement-illustration-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/hc/lux_1.png",
    alt: "achievement illustration",
    class: "achievement-illustration"
  })
], -1))
const _hoisted_10 = { class: "achievement-cta-wrap" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import ButtonShareOnLinkedin from '../ui/ButtonShareOnLinkedin.vue';
import BaseAchivementModal from '@/components/achivements/modal.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    challengeName: null,
    userNick: null,
    challengeId: null
  },
  emits: ["closed"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    challengeName: string;
    userNick: string;
    challengeId?: number | string;
}

const { t } = useI18n();
const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));





const achivementModal = ref<InstanceType<typeof BaseAchivementModal> | null>(null);

const shareUrl = computed(() => {
    if (!props.challengeId || !store.getters.currentUser?.id) {
        return '';
    }

    return `${process.env.VUE_APP_SHARE_URL}achievement/challenge/${props.challengeId}/user/${store.getters.currentUser.id}`;
});

const open = async () => {
    await achivementModal.value?.open();
};

let onModalHidden: (() => void) | null = null;

onMounted(() => {
    const modalEl = document.getElementById('challenge_achievement_modal');

    if (!modalEl) {
        return;
    }

    onModalHidden = () => {
        emit('closed');
    };

    modalEl.addEventListener('hidden.bs.modal', onModalHidden);
});

onBeforeUnmount(() => {
    const modalEl = document.getElementById('challenge_achievement_modal');

    if (modalEl && onModalHidden) {
        modalEl.removeEventListener('hidden.bs.modal', onModalHidden);
    }
});

expose({
    open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAchivementModal, {
    ref_key: "achivementModal",
    ref: achivementModal,
    target: "challenge_achievement_modal"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("h3", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.achivement.challenge.title`)) + " ", 1),
          _hoisted_5
        ])
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.achivement.challenge.message_1`, { user: props.userNick || 'No nick' })), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.achivement.challenge.message_2`, { challenge: props.challengeName })), 1),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(ButtonShareOnLinkedin, {
            url: _unref(shareUrl),
            disabled: !_unref(shareUrl)
          }, null, 8, ["url", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})